import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Sidebar from './components/Sidebar';
// import FAQs from './pages/FAQs.jsx';
import Privacy from './pages/Privacy.jsx';
import './MediaQuery.css';
import Terms from './pages/Terms.jsx';
import PrivacyAugUpdated from './pages/PrivacyAugUpdated.jsx';
// import TermsJuly from './pages/TermsJuly.jsx';
// import Term1 from './pages/Term1.jsx';
// import TermsUpdate from './pages/TermsUpdate.jsx';
// import Accordion from './pages/Accordion.js';

const App = () => {
  return (
    // <div className='wrapper'>
    //             <Accordion />
    //           </div>
   
     <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
      <div className='App'>
        <Sidebar>
          <Routes>
            <Route path="/" element={<Terms />} />
            {/* <Route path="/" element={<TermsJuly />} /> */}
            {/* <Route index path="/privacy-policy" element={<Privacy />} /> */}
            <Route index path="/privacy-policy" element={<PrivacyAugUpdated />} />
            {/* <Route path="/" element={<TermsUpdate />} /> */}
            {/* <Route path="/faqs" element={<FAQs />} /> */}
            {/* <Route path="/faqs" element={<Accordion />} /> */}
          </Routes>
        </Sidebar>
      </div>
    </BrowserRouter> 

  );
};

export default App;